
import React, { useState } from 'react';
import Subcriber from './Subcriber';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { useCompanySubscriberContext } from '../context/companysubscriber_context';
import loadingImage from '../images/preloader.gif';
import { useUserContext } from '../context/user_context';

const Subscribers = () => {
  const history = useHistory();
  const { state } = useCompanySubscriberContext();
  const { companySubscribers } = state;
  const { user } = useUserContext();

  const [nameFilter, setNameFilter] = useState('');

  const handleBackButtonClick = () => {
    history.goBack();
  };

  const handleMultiStepSubscriber = () => {
    history.push(`/addcompanymultisubscriber/${user.results.userAccounts[0].parent_membership_id}`);
  };

  const filteredSubscribers = companySubscribers.filter((subscriber) =>
    subscriber.name.toLowerCase().includes(nameFilter.toLowerCase())
  );

  if (!companySubscribers) {
    return (
      <>
        <img src={loadingImage} className="loading-img" alt="loading" />
        <div className="placeholder" style={{ height: '50vh' }}></div>
      </>
    );
  }

  return (
    <Wrapper>
      <div className="section-center">
        <div className="header">
          <h2 className="section-title">Company Subscribers ({filteredSubscribers.length})</h2>
        </div>
        <div className="smallheader">
          <input
            type="text"
            placeholder="Filter by name"
            value={nameFilter}
            onChange={(e) => setNameFilter(e.target.value)}
          />
          <div className="button-group">
            <button onClick={handleMultiStepSubscriber}>Add Subscriber Multistep</button>
            <button onClick={handleBackButtonClick}>Back</button>
          </div>
        </div>
        <div className="cocktails-center">
          {filteredSubscribers.map((item) => (
            <Subcriber key={item.id} {...item} />
          ))}
        </div>
      </div>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  padding: 2rem 0;
  background: var(--clr-white);

  .header {
    margin-bottom: 1rem;
    text-align: center;
  }

  .section-title {
    font-size: 1.75rem;
    text-transform: capitalize;
    letter-spacing: var(--mainSpacing);
    margin-bottom: 2rem;
    margin-top: 1rem;
  }

  .smallheader {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
    padding: 0 1rem;
  }

  .smallheader input[type='text'] {
    width: 100%;
    height: 2.5rem;
    padding: 0.5rem 1rem;
    background: var(--clr-grey-10);
    border-radius: 8px;
    border: 1px solid transparent;
    font-size: 1rem;
    color: var(--clr-grey-5);
  }

  .smallheader input[type='text']::placeholder {
    color: var(--clr-grey-5);
  }

  .button-group {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }

  .button-group button {
    background-color: var(--clr-primary-1);
    color: var(--clr-white);
    padding: 0.6rem 1rem;
    border: none;
    cursor: pointer;
    font-size: 1rem;
    border-radius: 8px;
    width: 100%;
  }
  @media screen and (min-width: 768px) {
    .smallheader {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }

    .smallheader input[type='text'] {
      width: 60%;
    }

    .button-group {
      flex-direction: row;
      gap: 1rem;
      width: auto;
    }

    .button-group button {
      width: auto;
    }
  }

  .cocktails-center {
    display: grid;
    gap: 1.5rem;
    padding: 0 1rem;
  }

  @media screen and (min-width: 576px) {
    .cocktails-center {
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    }
  }

  @media screen and (min-width: 992px) {
    .section-title {
      font-size: 2rem;
    }
  }
`;

export default Subscribers;

// import React, { useState } from 'react';
// import Subcriber from './Subcriber';
// import styled from 'styled-components';
// import { useHistory } from 'react-router-dom';
// import { useCompanySubscriberContext } from '../context/companysubscriber_context';
// import loadingImage from '../images/preloader.gif';
// import { useUserContext } from '../context/user_context';

// const Subscribers = () => {
//   const history = useHistory();
//   const { state } = useCompanySubscriberContext();
//   const { companySubscribers } = state;
//   const { user } = useUserContext();

//   const [nameFilter, setNameFilter] = useState('');

//   const handleBackButtonClick = () => {
//     history.goBack();
//   };

//   const handleAddCompanySubscriber = () => {
//     history.push(`/addcompanysubscriber/${user.results.userAccounts[0].parent_membership_id}`);
//   };

//   const handleMultiStepSubscriber = () => {
//     history.push(`/addcompanymultisubscriber/${user.results.userAccounts[0].parent_membership_id}`);
//   };

//   // Filtered subscribers based on name filter
//   const filteredSubscribers = companySubscribers.filter((subscriber) =>
//     subscriber.name.toLowerCase().includes(nameFilter.toLowerCase())
//   );

//   if (!companySubscribers) {
//     return (
//       <>
//         <img src={loadingImage} className="loading-img" alt="loading" />
//         <div className="placeholder" style={{ height: '50vh' }}></div>
//       </>
//     );
//   }

//   return (
//     <Wrapper>
//       <div className="section-center">
//         <div className="header">
//           <h2 className="section-title">Company Subscribers ({filteredSubscribers.length})</h2>
//         </div>
//         <div className="smallheader">
//           <input
//             type="text"
//             placeholder="Filter by name"
//             value={nameFilter}
//             onChange={(e) => setNameFilter(e.target.value)}
//             style={{
//               width: '600px',
//               height: '40px',
//               padding: '0.25rem',
//               paddingLeft: '1rem',
//               background: 'var(--clr-grey-10)',
//               borderTopLeftRadius: 'var(--radius)',
//               borderBottomLeftRadius: 'var(--radius)',
//               borderTopRightRadius: 'var(--radius)',
//               borderBottomRightRadius: 'var(--radius)',
//               borderColor: 'transparent',
//               fontSize: '1rem',
//               flex: '1 0 auto',
//               color: 'var(--clr-grey-5)',
//             }}
//           />
//           {/* <button onClick={handleAddCompanySubscriber}>Add Subscriber</button> */}
//           <button onClick={handleMultiStepSubscriber}>Add Subscriber Multistep</button>
//           <button onClick={handleBackButtonClick}>Back</button>
//         </div>
//         <div className="cocktails-center">
//           {filteredSubscribers.map((item) => (
//             <Subcriber
//               key={item.id}
//               {...item}            
//             />
//           ))}
//         </div>
//       </div>
//     </Wrapper>
//   );
// };

// const Wrapper = styled.section`
//   h3, h4 {
//     color: var(--clr-primary-1);
//   }
//   padding: 2rem 0;
//   background: var(--clr-white);

//   .header h3 {
//     margin-bottom: 2rem;
//   }

//   p {
//     margin-bottom: 0;
//     line-height: 1.8;
//     color: var(--clr-primary-3);
//   }

//   .smallheader {
//     display: grid;
//     grid-template-columns: auto 200px 100px;
//     align-items: center;
//     justify-content: space-between;
//     margin-bottom: 0.5rem;
//     padding: 1rem;
//   }

//   .smallheader button {
//     background-color: var(--clr-primary-1);
//     color: var(--clr-white);
//     padding: 0.5rem;
//     border: none;
//     cursor: pointer;
//     font-size: 1rem;
//     border-radius: 10px;
//   }

//   .smallheader input[type='text'] {
//     height: 2rem;
//     padding: 0.25rem 1rem;
//     background: var(--clr-grey-10);
//     border-radius: 10px;
//     border: 1px solid transparent;
//     font-size: 1rem;
//     color: var(--clr-grey-5);
//     flex: 1;
//     margin-left: 1rem;
//   }

//   .smallheader input[type='text']::placeholder {
//     color: var(--clr-grey-5);
//   }

//   .header {
//     display: grid;
//     grid-template-columns: 1fr 1fr 1fr;
//     margin-bottom: 1rem;
//     grid-gap: 0.5rem;
//   }

//   .section-title {
//     font-size: 2rem;
//     text-transform: capitalize;
//     letter-spacing: var(--mainSpacing);
//     text-align: center;
//     margin-bottom: 3.5rem;
//     margin-top: 1rem;
//   }

//   .cocktails-center {
//     width: var(--smallWidth);
//     margin: 0 auto;
//     max-width: var(--fullWidth);
//     display: grid;
//     row-gap: 2rem;
//     column-gap: 2rem;
//   }

//   @media screen and (min-width: 576px) {
//     .cocktails-center {
//       grid-template-columns: repeat(auto-fill, minmax(338.8px, 1fr));
//     }
//   }
// `;

// export default Subscribers;
